import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from "highcharts/highstock";
import {high_colors} from "../general-chart/general-chart.component";
import { HighchartsChartComponent, providePartialHighcharts } from "highcharts-angular";

@Component({
  selector: 'app-stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.scss'],
  imports: [HighchartsChartComponent],
  providers: [
    providePartialHighcharts({
      modules: () => [
        import('highcharts/esm/modules/stock'),
      ]
    })
  ],
  standalone: true,
})
export class StackedBarChartComponent implements OnInit{
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = 'chart';
  chartOptions: Highcharts.Options = {};
  @Input() series: any = null;

  ngOnInit(): void {
    this.initChart()
  }

  initChart() {
    this.chartOptions = {
      chart: {
        height: '500px',
        type: 'column'
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      colors: high_colors,
      xAxis: {
        categories: ['1'],
        gridLineColor: 'var(--border)'
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            format: '{y}%'
          }
        }
      },
      series: this.series,
      tooltip: {
        valueSuffix: '%',
        valueDecimals: 2,
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          format: '{value}%'
        },
        minorGridLineWidth: 0,
      }
    };
  }
}
